import { messages } from '../state/session.js';

/**
 * Bronvermelding van het beeld (docs/LICENSES.md): pictogrammen, iconen en illustraties zijn eigen
 * werk van AMUMIN (docs/ux/pictogrammen.md). Alleen in Instellingen > Over, niet onder elke pagina.
 */
export function Credits() {
  return <p class="app-credits">{messages.value.design.credits}</p>;
}
